import Instance from '../../../Axios';

// New Actions for the app

const GetProduto = (id) => async (dispatch) => {
  console.log('id', id);
  await Instance()
    .get(`/backend/produtos/${id}`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_PRODUTO', payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetProduto;
